export default __webpack_public_path__ + "static/banner2-5c7c846f0e62b8956ab5a60a66a574dd.png";